import { Table } from "react-bootstrap";
import {
  useBillingDraft,
  useBillingDraftForB2b,
  useBillingDraftWithCatch,
} from "../../provider/billingDraftProvider";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import { useBilling } from "../Kitchen/billingProvider";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch, useSelector } from "react-redux";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { useKotDraft } from "../Kitchen/KOT/draftProvider";
import { startTransition, useEffect, useMemo, useState } from "react";
import config from "../../config";
import moment from "moment";
import Loader from "../loader";
import { useKotDraftB2b } from "../Kitchen/KOT/kotDraftB2bProvider";
import { Popconfirm } from "antd";

const KoTDraftItems = ({
  actionKey = "",
  moveDraftToCurrent = () => {},
  handleDraftItemRemove = () => {},
}) => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const country = useCountry();
  const currencyFormatter = useCurrency();
  const [loading, setLoading] = useState(true);
  const orderTypes = {
    dine_in: "Dine In",
    delivery: "Delivery",
    parcel: "Parcel",
  };
  const productList = useSelector((state) => state.products.productList);

  const { getTaxableValueAndTaxs } = useBilling();
  const [kotDraft, setKotDraft] = useKotDraft([]);
  const [kotDraftB2b, setKotDraftB2b] = useKotDraftB2b([]);
  const [draftBillCatch] = useBillingDraftWithCatch();
  const getRestaurantDraft = async () => {
    try {
      const res = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "getDraft",
          shopId: shopDetails.shopId,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
          shopTypeandCustomertype:
            actionKey === "draft-get"
              ? "draft"
              : actionKey === "restaurant-get"
              ? "restaurant"
              : actionKey === "draft-b2b-get"
              ? "draft-b2b"
              : actionKey === "restaurant-b2b-get"
              ? "restaurant-b2b"
              : actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();

      if (data.status === "SUCCESS") {
        if (actionKey === "restaurant-get") {
          const updatedDraft = data.data.map((i) => {
            const isOtherCharges = i?.isOtherCharges;

            let products = i.items.map((j) => {
              const isTax = i?.isTax;
              const isItemDiscount = i?.isDiscount;
              const productFromList = productList.find(
                (product) => product.productId === j.productId
              );
              if (productFromList) {
                const product = getTaxableValueAndTaxs(
                  productFromList,
                  productFromList.productPrice,
                  j.count,
                  isItemDiscount,
                  isTax
                );
                return product;
              }
              return null;
            });
            products = products.filter((i) => i);
            let totalAmount = products.reduce((a, c) => a + c.itemTotal, 0);

            if (i.isAddDiscount) {
              if (i.footerData?.discountType === "flat") {
                totalAmount = totalAmount - i.footerData?.discount;
              } else if (i.footerData?.discountType === "percentage") {
                totalAmount =
                  totalAmount - totalAmount * (i.footerData?.discount / 100);
              }
            }
            if (isOtherCharges) {
              const otherChargesValue = i.footerData?.otherCharges.reduce(
                (a, c) => a + parseFloat(c.price || 0),
                0
              );

              totalAmount = totalAmount + (otherChargesValue || 0);
            }
            return {
              ...i,
              totalAmount: totalAmount,
              items: products,
            };
          });
          setKotDraft(updatedDraft);
        } else if (actionKey === "restaurant-b2b-get") {
          setKotDraftB2b(data.data);
        }
      }
    } catch (error) {
      console.log("getRestaurantDraftError", error);
    } finally {
      setLoading(false);
    }
  };

  const data = useMemo(() => {
    const data = actionKey === "restaurant-get" ? kotDraft : kotDraftB2b;
    if (actionKey === "restaurant-get") {
      const result = draftBillCatch.filter((i) => i.action === "draft");
      return [...data, ...result];
    } else if (actionKey === "draft-b2b") {
      const result = draftBillCatch.filter((i) => i.action === "draft-b2b");
      return [...data, ...result];
    }
    return data;
  }, [actionKey, draftBillCatch, kotDraft, kotDraftB2b]);
  useEffect(() => {
    if (shopDetails.shopId) {
      getRestaurantDraft();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopDetails.shopId]);

  return (
    <>
      {loading && (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      )}

      {!loading && (
        <Table>
          <thead>
            <tr>
              <th>Created At</th>
              <th>Mobile No.</th>
              <th>Name</th>
              <th>Order Type</th>
              <th>Order Id</th>
              <th>Table Number</th>
              <th>Waiter Name/Code</th>
              <th>Item Count</th>
              <th>Amount({country.CurrencySymbol})</th>
              <th>Actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length === 0 && (
              <tr
                style={{
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <td rowSpan={5} colSpan={12}>
                  No Draft Found
                </td>
              </tr>
            )}
            {data.map((data) => (
              <tr
                key={data.billId}
                style={{
                  background: "#feffff",
                }}
              >
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                    }}
                  >
                    <p>
                      {moment(data.billingDate, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )}
                      {"  "}
                      {moment(data.billingTime, "HH:mm")
                        .utcOffset("+05:30")
                        .format("hh:mm")}
                    </p>
                  </div>
                </td>
                <td style={{ textAlign: "left" }}>
                  <p>
                    {" "}
                    {data.customerPhoneNumber
                      ? data.customerPhoneNumber
                      : "Nil"}{" "}
                  </p>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.customerName ? data.customerName : "Nil"}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{orderTypes[data.orderType]}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.orderId}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.tableNumber ? data.tableNumber : "Nil"}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.waiterName ? data.waiterName : "Nil"}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.items.length}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{currencyFormatter(data.totalAmount)}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <button
                      className="holdBtn"
                      style={{ width: "150px" }}
                      onClick={() => moveDraftToCurrent(data)}
                    >
                      Move to Billing
                    </button>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    <Popconfirm
                      title="Delete the Draft"
                      description="Are you sure you want to delete this?"
                      onConfirm={() => handleDraftItemRemove(data.billId)}
                      onCancel={() => {}}
                      okText={"Yes"}
                      cancelText={"No"}
                    >
                      <DeleteIcon className="deleteIcon" />
                    </Popconfirm>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

const DraftItems = ({
  actionKey = "",
  moveDraftToCurrent = () => {},
  handleDraftItemRemove = () => {},
}) => {
  const shopDetails = useSelector((state) => state.shopDetails);
  const country = useCountry();
  const [draftBillCatch, setDraftBillCatch] = useBillingDraftWithCatch();
  const currencyFormatter = useCurrency();
  const [loading, setLoading] = useState(true);

  const [draftBill, setDraftBill] = useBillingDraft([]);
  const [draftBillB2b, setDraftBillB2b] = useBillingDraftForB2b([]);
  const getDraft = async () => {
    try {
      const res = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "getDraft",
          shopId: shopDetails.shopId,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
          shopTypeandCustomertype:
            actionKey === "draft-get"
              ? "draft"
              : actionKey === "restaurant-get"
              ? "restaurant"
              : actionKey === "restaurant-b2b-get"
              ? "restaurant-b2b"
              : actionKey === "draft-b2b-get"
              ? "draft-b2b"
              : actionKey,
        }),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": `${config.newApiKey}`,
        },
      });
      const data = await res.json();

      if (data.status === "SUCCESS") {
        if (actionKey === "draft-get") {
          setDraftBill(data.data);
        } else if (actionKey === "draft-b2b-get") {
          setDraftBillB2b(data.data);
        }
      }
    } catch (error) {
      console.log("getRestaurantDraftError", error);
    } finally {
      setLoading(false);
    }
  };

  const data = useMemo(() => {
    const data = actionKey === "draft-get" ? draftBill : draftBillB2b;
    if (actionKey === "draft-get") {
      const result = draftBillCatch.filter((i) => i.action === "draft");
      return [...data, ...result];
    } else if (actionKey === "draft-b2b") {
      const result = draftBillCatch.filter((i) => i.action === "draft-b2b");
      return [...data, ...result];
    }
    return data;
  }, [actionKey, draftBill, draftBillB2b, draftBillCatch]);

  const addToDraft = async (payload, actionKey) => {
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "createDraft",
          ...payload,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
          shopTypeandCustomertype:
            actionKey === "draft-get"
              ? "draft"
              : actionKey === "restaurant-get"
              ? "restaurant"
              : actionKey === "draft-b2b-get"
              ? "draft-b2b"
              : actionKey === "restaurant-b2b-get"
              ? "restaurant-b2b"
              : actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setDraftBillCatch((prev) => {
          const result = prev.filter(
            (draft) => draft.billId !== payload.billId
          );
          console.log("result222", result);
          return result;
        });
        getDraft();
        console.log("Successfully added to draft");
      }
    } catch (error) {
      console.log("addToDraftError", error);
    } finally {
    }
  };

  useEffect(() => {
    console.log("draftBillCatch", draftBillCatch);
    if (draftBillCatch.length) {
      (async function () {
        await Promise.all(
          draftBillCatch?.map?.(async (data) => {
            await addToDraft(data, data?.action);
          })
        );
      })();
    }
  }, [draftBillCatch]);

  useEffect(() => {
    if (shopDetails.shopId) {
      getDraft();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopDetails.shopId]);

  return (
    <>
      {loading && (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      )}

      {!loading && (
        <Table>
          <thead>
            <tr>
              <th>Created At</th>
              <th>Mobile No.</th>
              <th>Name</th>
              <th>Item Count</th>
              <th>Amount({country.CurrencySymbol})</th>
              <th>Actions</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length === 0 && (
              <tr
                style={{
                  textAlign: "center",
                  width: "100%",
                }}
              >
                <td rowSpan={5} colSpan={12}>
                  No Draft Found
                </td>
              </tr>
            )}
            {data.map((data) => (
              <tr
                key={data.billId}
                style={{
                  background: "#feffff",
                }}
              >
                <td>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                    }}
                  >
                    <p>
                      {moment(data.billingDate, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )}{" "}
                      {moment(data.billingTime, "HH:mm")
                        .utcOffset("+05:30")
                        .format("hh:mm")}
                    </p>
                  </div>
                </td>
                <td style={{ textAlign: "left" }}>
                  <p>
                    {data.customerData.customerPhoneNumber
                      ? data.customerData.customerPhoneNumber
                      : "-"}{" "}
                  </p>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>
                      {data.customerData.customerName
                        ? data.customerData.customerName
                        : "-"}
                    </p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{data.items?.length}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <p>{currencyFormatter(data.totalAmount)}</p>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "left",
                    }}
                  >
                    <button
                      className="holdBtn"
                      style={{ width: "150px" }}
                      onClick={() => moveDraftToCurrent(data)}
                    >
                      Move to Billing
                    </button>
                  </div>
                </td>
                <td>
                  <div
                    style={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                    onClick={() => handleDraftItemRemove(data.billId)}
                  >
                    <DeleteIcon className="deleteIcon" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

const DraftTable = ({ goToCurrent = () => {} }) => {
  const [draftBill, setDraftBill] = useBillingDraft();
  const [b2bDraft, setB2bDraft] = useBillingDraftForB2b();
  const shopType = useSelector((state) => state.shopDetails.shopType);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [kotDraftBill, setKotDraftBill] = useKotDraft();
  const [kotDrafB2BtBill, setKotDraftB2BtBill] = useKotDraftB2b();
  const { setCustomerData } = useCustomerData();
  const { setFooterData } = useFooterData();
  const { uniqueIdentity: identifier = false } = useSelector(
    (state) => state.shopDetails.advanceSettings || {}
  );
  const { productList: products } = useSelector((state) => state.products);
  const country = useCountry();
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const dispatch = useDispatch();
  const {
    addProductToBilling,
    state: { addedProducts, b2bBill = false },
    setOrderTypeAndId,
  } = useBilling();
  const newInvoicesettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );

  const deleteDraftById = async (billId) => {
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "deleteDraft",
          billId: billId,
          shopTypeandCustomertype: "delete",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        if (shopType === "Restaurant" && b2bBill === false) {
          setKotDraftBill((prev) =>
            prev.filter((draft) => draft.billId !== billId)
          );
        } else if (shopType === "Restaurant" && b2bBill === true) {
          setKotDraftB2BtBill((prev) =>
            prev.filter((draft) => draft.billId !== billId)
          );
        } else if (shopType !== "Restaurant" && b2bBill === false) {
          setDraftBill((prev) =>
            prev.filter((draft) => draft.billId !== billId)
          );
        } else if (shopType !== "Restaurant" && b2bBill === true) {
          setB2bDraft((prev) =>
            prev.filter((draft) => draft.billId !== billId)
          );
        }
      }
    } catch (err) {
      console.error("Error: deleteDraftById", err);
    }
  };

  const getCustomerDetails = async (customerPhoneNo, uniqueId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          ...(identifier && uniqueId
            ? { uniqueIdentity: uniqueId }
            : {
                phoneNumber: customerPhoneNo
                  ? `${shopDetails.country.dialCode}${customerPhoneNo}`
                  : undefined,
              }),
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "ERROR") {
          setCustomerData((prev) => ({
            ...prev,
            customerName: "",
            loyaltyPoints: "",
            outstandingAmount: "",
            availableLoyaltyPoints: "",
            loyalty: {},
          }));
        }
        if (data.customerName) {
          setCustomerData((prev) => ({
            ...prev,
            customerName: data.customerName,
          }));
        }
        if (data.customerPhoneNumber) {
          setCustomerData((prev) => ({
            ...prev,
            customerPhoneNumber: data.customerPhoneNumber.replace(
              country.dialCode,
              ""
            ),
          }));
        }
        if (data.uniqueIdentity) {
          setCustomerData((prev) => ({
            ...prev,
            uniqueId: data.uniqueIdentity,
          }));
        }
        if (data.loyaltyPoints) {
          setCustomerData((prev) => ({
            ...prev,
            loyaltyPoints: data.loyaltyPoints,
            availableLoyaltyPoints: data.loyaltyPoints,
          }));
        }
        if (data.outStanding) {
          setCustomerData((prev) => ({
            ...prev,
            outstandingAmount: data.outStanding,
          }));
        }
      })
      .catch((err) => {
        console.error("Error: getCustomerDetail", err);
      });
  };

  const moveDraftToCurrent = (data) => {
    if (data.customerData?.customerPhoneNumber) {
      getCustomerDetails(data.customerData?.customerPhoneNumber);
    }
    if (shopType === "Restaurant") {
      if (addedProducts.length > 0) {
        return alert("Clear the bill before moving to current.");
      }
      const isTax = data?.isTax;
      const isItemDiscount = data?.isDiscount;
      const isAddDiscount = data?.isAddDiscount;
      const isMrp = data?.isMrp;
      const isOtherCharges = data?.isOtherCharges;
      const isRoundOff = data?.isRoundOff;
      const payload = {
        ...newInvoicesettings,
        ...(isTax && {
          itemleveltax: isTax,
        }),
        ...(isItemDiscount && {
          itemdiscount: isItemDiscount,
        }),
        ...(isMrp && {
          itemmrp: isMrp,
        }),
        ...(isOtherCharges && {
          othercharges: isOtherCharges,
        }),
        ...(isRoundOff && {
          roundOff: isRoundOff,
        }),
        ...(isAddDiscount && {
          adddiscount: isAddDiscount,
        }),
      };
      dispatch({
        type: "INVOICE-NEWBILLSETTINGS-TEMP",
        payload: payload,
      });
      startTransition(() => {
        const products = data.items;
        console.log("products333", data, products);
        data.items.forEach((i) => {
          if (i.isExist === false) {
            return addProductToBilling(i, isItemDiscount, isTax);
          }
          const getObj = products.find((j) => j.productId === i.productId);

          if (getObj) {
            addProductToBilling(
              {
                ...getObj,
                isExist: true,
                count: i.count,
              },
              isItemDiscount,
              isTax
            );
          }
        });

        setOrderTypeAndId(data.orderType, data.orderId);

        const footerData = data?.footerData;
        if (footerData) {
          if (!isAddDiscount) {
            footerData.discount = "";
            footerData.discountType = "";
          }
          if (!isOtherCharges) {
            footerData.otherCharges = [];
          }
          setFooterData(footerData || {});
        }
        if (data.customerData) {
          setCustomerData(data.customerData || {});
        }
        deleteDraftById(data.billId);
      });
    } else {
      if (addedProducts.length > 0) {
        return alert("Clear the bill before moving to current.");
      }
      const isTax = data?.isTax;
      const isItemDiscount = data?.isDiscount;
      const isAddDiscount = data?.isAddDiscount;
      const isMrp = data?.isMrp;
      const isOtherCharges = data?.isOtherCharges;
      const isRoundOff = data?.isRoundOff;
      const payload = {
        ...newInvoicesettings,
        ...(isTax && {
          itemleveltax: isTax,
        }),
        ...(isItemDiscount && {
          itemdiscount: isItemDiscount,
        }),
        ...(isMrp && {
          itemmrp: isMrp,
        }),
        ...(isOtherCharges && {
          othercharges: isOtherCharges,
        }),
        ...(isRoundOff && {
          roundOff: isRoundOff,
        }),
        ...(isAddDiscount && {
          adddiscount: isAddDiscount,
        }),
      };
      dispatch({
        type: "INVOICE-NEWBILLSETTINGS-TEMP",
        payload: payload,
      });
      data.items.forEach((i) => {
        if (i.isExist === false) {
          return addProductToBilling(i, isItemDiscount, isTax);
        }
        const getObj = products.find((j) => j.productId === i.productId);

        if (getObj) {
          addProductToBilling(
            {
              ...getObj,
              isExist: true,
              count: i.count,
            },
            isItemDiscount,
            isTax
          );
        }
      });

      const footerData = data?.footerData;
      if (footerData) {
        if (!isAddDiscount) {
          footerData.discount = "";
          footerData.discountType = "";
        }
        if (!isOtherCharges) {
          footerData.otherCharges = [];
        }
        setFooterData(footerData || {});
      }

      setCustomerData(data.customerData);

      if (b2bBill) {
        const filteredArr = b2bDraft.filter(
          (draft) => draft.billId !== data.billId
        );
        setB2bDraft(filteredArr);
      } else {
        const filteredArr = draftBill.filter(
          (draft) => draft.billId !== data.billId
        );
        setDraftBill(filteredArr);
      }
      deleteDraftById(data.billId);
    }
    goToCurrent();
  };
  const handleDraftItemRemove = (billId) => {
    if (shopType === "Restaurant" && b2bBill === false) {
      const filteredArr = kotDraftBill.filter(
        (draft) => draft.billId !== billId
      );
      setKotDraftBill(filteredArr);
    } else if (shopType === "Restaurant" && b2bBill === true) {
      const filteredArr = kotDrafB2BtBill.filter(
        (draft) => draft.billId !== billId
      );
      setKotDraftB2BtBill(filteredArr);
    } else if (shopType !== "Restaurant" && b2bBill === false) {
      const filteredArr = draftBill.filter((draft) => draft.billId !== billId);
      setDraftBill(filteredArr);
    } else if (shopType !== "Restaurant" && b2bBill === true) {
      const filteredArr = b2bDraft.filter((draft) => draft.billId !== billId);
      setB2bDraft(filteredArr);
    }
    deleteDraftById(billId);
  };
  return (
    <div style={{ marginTop: "10px" }} className="table-wrapper">
      <div className="product-table" style={{ background: "#feffff" }}>
        {shopType === "Restaurant" && !b2bBill && (
          <KoTDraftItems
            actionKey="restaurant-get"
            moveDraftToCurrent={moveDraftToCurrent}
            handleDraftItemRemove={handleDraftItemRemove}
          />
        )}

        {shopType === "Restaurant" && b2bBill && (
          <KoTDraftItems
            actionKey="restaurant-b2b-get"
            moveDraftToCurrent={moveDraftToCurrent}
            handleDraftItemRemove={handleDraftItemRemove}
          />
        )}

        {shopType !== "Restaurant" && (
          <>
            {b2bBill && (
              <DraftItems
                moveDraftToCurrent={moveDraftToCurrent}
                handleDraftItemRemove={handleDraftItemRemove}
                actionKey="draft-b2b-get"
              />
            )}
            {!b2bBill && (
              <DraftItems
                moveDraftToCurrent={moveDraftToCurrent}
                handleDraftItemRemove={handleDraftItemRemove}
                actionKey="draft-get"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DraftTable;
